import { Component, Input, OnInit } from "@angular/core";
import { MatTableDataSource } from "@angular/material/table";
import { data } from "jquery";

@Component({
  selector: "app-items-grid",
  templateUrl: "./items-grid.component.html",
  styleUrls: ["./items-grid.component.css"],
})
export class ItemsGridComponent implements OnInit {
  @Input() dataSource: any;
  @Input() data: any;
  @Input() isAction: boolean = false;
  @Input() searchText: '';
  public columnsToDisplay: Array<string> = [];
  constructor() {}

  ngOnInit() {
    this.columnsToDisplay = Object.keys(this.dataSource[0]);
    if(this.isAction == true){
      this.columnsToDisplay.push('Actions');
    }
  }
  getHeader(colName) {
    if (colName == "null") {
      return "";
    }
    return colName;
  }
}
